import React from 'react'
import convertUnit from 'lib/unit'
import {RoboyuColorTheme} from '../../../types'
import {RoboyuAssetProps} from './RoboyuAssetProps'

export default function RoboyuFly({
  width = convertUnit(519),
  height = convertUnit(673),
  colorTheme = 'blue',
  ...props
}: RoboyuAssetProps) {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      viewBox="0 0 2000 2044"
      fill="none">
      <g filter="url(#filter0_d_4220_34006)">
        <path
          d="M1045.3 1420.55L1073.5 1422.05C1004.7 1350.15 934 1277.47 878.725 1223.42C868.108 1223.24 857.658 1222.98 847.375 1222.65C898.825 1276.5 971.775 1348.77 1045.3 1420.55Z"
          fill="#6EC6F0"
        />
        <path
          d="M1529.5 1665.6L1535 1662.65C1518.62 1613.7 1499.5 1556.85 1480 1499.52C1476.97 1502.4 1473.95 1505.22 1470.88 1507.97C1491.35 1563.57 1511.8 1618.4 1529.5 1665.6Z"
          fill="#92D6F6"
        />
        <path
          d="M1386.75 1376.5C1351 1291.33 1314.6 1205.85 1282.52 1132.43C1192.05 1187.23 1077.75 1223.25 933.499 1223.83H928.824C983.474 1282.33 1049.57 1351.78 1119.15 1424.1C1223.3 1426.5 1311.77 1407.95 1386.75 1376.5Z"
          fill="#6EC6F0"
        />
        <path
          d="M766.249 1218.52C757.083 1217.87 748.066 1217.16 739.199 1216.38C829.199 1293.35 921.149 1370.43 976.274 1416.38L982.049 1416.73C932.974 1371.25 850.449 1294.97 766.249 1218.52Z"
          fill="#6EC6F0"
        />
        <path
          d="M1326.72 1691.03C1326.72 1691.03 1299.05 1661.03 1256.12 1615.23C1253.62 1615.8 1251.27 1616.35 1248.82 1616.88C1295.9 1661.83 1326.72 1691.03 1326.72 1691.03Z"
          fill="#92D6F6"
        />
        <path
          d="M1449.08 1526.2C1401.83 1563.15 1349.08 1588.42 1294.53 1605C1331.45 1642.82 1367.5 1679.57 1401.5 1714C1438.93 1705.02 1475.31 1692.08 1510 1675.4C1492.5 1631.87 1471.63 1580.85 1449.08 1526.2Z"
          fill="#92D6F6"
        />
        <path
          d="M1634.32 1941.25C1615.92 1912.62 1574.87 1858.2 1547.55 1821.25C1538.8 1825.33 1529.47 1829.22 1519.57 1832.9C1595 1908.05 1641.92 1953.05 1634.32 1941.25Z"
          fill="#E1F4FD"
        />
        <path
          d="M1582.83 1806.8L1581.58 1802.98H1581.4C1582.33 1805.53 1582.83 1806.8 1582.83 1806.8Z"
          fill="#BAE6FB"
        />
        <path
          d="M1357.5 1171.22C1352.03 1172.75 1380 1256.22 1417.9 1362.35C1422.13 1360.27 1426.28 1358.15 1430.4 1355.97C1393.45 1251.02 1362.9 1169.7 1357.5 1171.22Z"
          fill="#6EC6F0"
        />
        <path
          d="M1564.5 1814.9C1564.38 1814.28 1564.22 1813.67 1564.03 1813.07C1561.53 1814.42 1559.03 1815.75 1556.3 1817.07C1561.93 1821.35 1565.6 1822.07 1564.5 1814.9Z"
          fill="#E1F4FD"
        />
        <path
          d="M1507.02 1308.05C1494.67 1245.05 1469.05 1115.43 1443.2 990.926C1439.95 994.959 1436.62 998.967 1433.2 1002.95C1461.15 1124.45 1490.85 1248.63 1505.45 1309.18L1507.02 1308.05Z"
          fill="#6EC6F0"
        />
        <path
          d="M1370.75 688.252C1363.25 689.377 1396.7 843.852 1433.25 1002.95C1436.58 998.952 1439.92 994.944 1443.25 990.927C1410.85 835.027 1378.15 687.177 1370.75 688.252Z"
          fill="#5DB9E9"
        />
        <path
          d="M777.074 1136.32C768.724 1136.95 798.249 1171.32 847.374 1222.65C857.657 1222.97 868.107 1223.22 878.724 1223.42C824.849 1170.72 785.599 1135.7 777.074 1136.32Z"
          fill="#5DB9E9"
        />
        <path
          d="M478.624 976.073C468.799 981.623 601.724 1098.82 739.199 1216.37C748.049 1217.14 757.066 1217.86 766.249 1218.52C629.724 1094.62 488.749 970.348 478.624 976.073Z"
          fill="#5DB9E9"
        />
        <path
          d="M1401.5 1714C1445.08 1758.23 1485.27 1798.68 1519.57 1832.9C1529.47 1829.22 1538.8 1825.34 1547.55 1821.25C1530.45 1798.18 1518.7 1781.98 1521.28 1783.25C1525.73 1785.48 1544.98 1808.43 1556.28 1817.03C1558.9 1815.7 1561.48 1814.38 1564 1813.03C1560.65 1801.85 1540.1 1749.5 1510.07 1675.35C1475.36 1692.06 1438.96 1705.01 1401.5 1714Z"
          fill="#BAE6FB"
        />
        <path
          d="M1045.3 1420.55C1119.85 1493.3 1194.98 1565.55 1248.83 1616.88C1251.33 1616.35 1253.83 1615.8 1256.13 1615.23C1208.43 1564.25 1141.9 1493.55 1073.5 1422.05L1045.3 1420.55Z"
          fill="#58B8E8"
        />
        <path
          d="M982.05 1416.8L976.275 1416.45C1007.93 1442.87 1027.5 1459 1027.5 1459C1027.5 1459 1010.3 1443.02 982.05 1416.8Z"
          fill="#58B8E8"
        />
        <path
          d="M1386.75 1376.5C1311.75 1407.98 1223.3 1426.5 1119.25 1424C1176.75 1484 1236.75 1545.73 1294.63 1604.93C1349.2 1588.35 1401.93 1563.07 1449.18 1526.12C1429.25 1478.2 1408.13 1427.4 1386.75 1376.5Z"
          fill="#58B8E8"
        />
        <path
          d="M1529.5 1665.6C1555.8 1735.6 1576.02 1788.95 1581.4 1803.1H1581.57C1576.8 1788.62 1558.85 1734.12 1535 1662.77L1529.5 1665.6Z"
          fill="#BAE6FB"
        />
        <path
          d="M1514.65 1347.1C1514.65 1347.1 1511.85 1332.65 1507.02 1308.05L1505.5 1309.18C1511.25 1333.08 1514.65 1347.1 1514.65 1347.1Z"
          fill="#58B8E8"
        />
        <path
          d="M1282.5 1132.4C1233.9 1021.25 1195.23 937.824 1183.73 925.349C1145.48 883.774 738.125 953.599 738.125 953.599C738.125 953.599 735.625 983.374 789.65 1066.67C802.15 1085.82 855.025 1144.85 928.8 1223.8H933.475C1077.75 1223.22 1192.05 1187.2 1282.5 1132.4Z"
          fill="#5DB9E9"
        />
        <path
          d="M1470.85 1507.98C1473.92 1505.23 1476.95 1502.4 1479.97 1499.53C1463.25 1450.45 1446.22 1401.05 1430.35 1355.98C1426.22 1358.15 1422.07 1360.28 1417.85 1362.35C1434.27 1408.28 1452.5 1458.43 1470.85 1507.98Z"
          fill="#58B8E8"
        />
        <path
          d="M1222.35 1637.8H1186.73C1179.57 1637.8 1173.78 1643.6 1173.78 1650.75V1691.35C1173.78 1698.5 1179.57 1704.3 1186.73 1704.3H1222.35C1229.5 1704.3 1235.3 1698.5 1235.3 1691.35V1650.75C1235.3 1643.6 1229.5 1637.8 1222.35 1637.8Z"
          fill="#94D7F6"
        />
        <path
          d="M1626.38 1655.27H1590.75C1583.6 1655.27 1577.8 1661.07 1577.8 1668.22V1708.82C1577.8 1715.98 1583.6 1721.77 1590.75 1721.77H1626.38C1633.53 1721.77 1639.33 1715.98 1639.33 1708.82V1668.22C1639.33 1661.07 1633.53 1655.27 1626.38 1655.27Z"
          fill="#94D7F6"
        />
        <path
          d="M1257.25 1475.7H1221.63C1214.47 1475.7 1208.68 1481.5 1208.68 1488.65V1529.25C1208.68 1536.4 1214.47 1542.2 1221.63 1542.2H1257.25C1264.4 1542.2 1270.2 1536.4 1270.2 1529.25V1488.65C1270.2 1481.5 1264.4 1475.7 1257.25 1475.7Z"
          fill="#94D7F6"
        />
        <path
          d="M1633.85 1862.27H1598.23C1591.07 1862.27 1585.28 1868.07 1585.28 1875.22V1915.82C1585.28 1922.98 1591.07 1928.77 1598.23 1928.77H1633.85C1641 1928.77 1646.8 1922.98 1646.8 1915.82V1875.22C1646.8 1868.07 1641 1862.27 1633.85 1862.27Z"
          fill="#94D7F6"
        />
        <path
          d="M1410.68 1767.5H1392.35C1388.66 1767.5 1385.68 1770.49 1385.68 1774.17V1795.05C1385.68 1798.74 1388.66 1801.72 1392.35 1801.72H1410.68C1414.36 1801.72 1417.35 1798.74 1417.35 1795.05V1774.17C1417.35 1770.49 1414.36 1767.5 1410.68 1767.5Z"
          fill="#94D7F6"
        />
        <path
          d="M1525.45 1357.15H1507.12C1503.44 1357.15 1500.45 1360.14 1500.45 1363.82V1384.7C1500.45 1388.39 1503.44 1391.37 1507.12 1391.37H1525.45C1529.14 1391.37 1532.12 1388.39 1532.12 1384.7V1363.82C1532.12 1360.14 1529.14 1357.15 1525.45 1357.15Z"
          fill="#94D7F6"
        />
        <path
          d="M1552.03 1562.15H1533.7C1530.01 1562.15 1527.03 1565.14 1527.03 1568.82V1589.7C1527.03 1593.38 1530.01 1596.37 1533.7 1596.37H1552.03C1555.71 1596.37 1558.7 1593.38 1558.7 1589.7V1568.82C1558.7 1565.14 1555.71 1562.15 1552.03 1562.15Z"
          fill="#94D7F6"
        />
        <path
          d="M1422.32 1562.15H1404C1400.31 1562.15 1397.32 1565.14 1397.32 1568.82V1589.7C1397.32 1593.38 1400.31 1596.37 1404 1596.37H1422.32C1426.01 1596.37 1429 1593.38 1429 1589.7V1568.82C1429 1565.14 1426.01 1562.15 1422.32 1562.15Z"
          fill="#94D7F6"
        />
        <path
          d="M1485.55 1771.18H1467.23C1463.54 1771.18 1460.55 1774.16 1460.55 1777.85V1798.73C1460.55 1802.41 1463.54 1805.4 1467.23 1805.4H1485.55C1489.24 1805.4 1492.23 1802.41 1492.23 1798.73V1777.85C1492.23 1774.16 1489.24 1771.18 1485.55 1771.18Z"
          fill="#94D7F6"
        />
        <path
          d="M1534.55 1866.43H1516.23C1512.54 1866.43 1509.55 1869.41 1509.55 1873.1V1893.98C1509.55 1897.66 1512.54 1900.65 1516.23 1900.65H1534.55C1538.24 1900.65 1541.23 1897.66 1541.23 1893.98V1873.1C1541.23 1869.41 1538.24 1866.43 1534.55 1866.43Z"
          fill="#94D7F6"
        />
        <path
          d="M1660.12 1965.7H1641.8C1638.11 1965.7 1635.12 1968.69 1635.12 1972.37V1993.25C1635.12 1996.94 1638.11 1999.92 1641.8 1999.92H1660.12C1663.81 1999.92 1666.8 1996.94 1666.8 1993.25V1972.37C1666.8 1968.69 1663.81 1965.7 1660.12 1965.7Z"
          fill="#94D7F6"
        />
        <path
          d="M716.825 877.026C732.375 843.526 800.4 932.251 806.825 945.276C813.25 958.301 749.5 1162.78 716.625 1175.73C683.75 1188.68 653.35 1013.7 716.825 877.026Z"
          fill="white"
        />
        <path
          d="M716.625 1175.73C715.425 1176.21 714.138 1176.44 712.845 1176.39C711.553 1176.34 710.285 1176.02 709.125 1175.45C693.75 1151.78 698.525 983.626 754.125 883.426C777.525 903.101 803.075 937.526 806.875 945.276C813.25 958.301 749.5 1162.78 716.625 1175.73Z"
          fill="#5D76A1"
        />
        <path
          d="M802.65 951.951C803.3 947.176 788.5 920.727 761.4 889.977C782.525 909.977 803.4 938.352 806.825 945.277C812.675 957.152 760.225 1128.18 725.975 1168.08C753.15 1125.25 782.125 1052.58 802.65 951.951Z"
          fill="#BDE5EE"
        />
        <path
          d="M753.951 991.624C742.176 874.874 847.151 814.674 983.176 805.024C1119.2 795.374 1234.75 840.024 1246.53 956.649C1258.3 1073.27 1161.7 1216.65 1025.68 1226.3C889.651 1235.95 765.726 1108.37 753.951 991.624Z"
          fill="white"
        />
        <path
          d="M1202.35 862.477C1189.4 916.202 1126.52 975.327 948.299 989.252C840.799 997.677 783.524 979.677 754.449 953.252C752.76 965.978 752.592 978.86 753.949 991.627C765.724 1108.38 889.649 1235.95 1025.67 1226.3C1161.7 1216.65 1258.3 1073.4 1246.52 956.652C1242.5 917.277 1226.75 886.127 1202.35 862.477Z"
          fill="#98B1DC"
        />
        <path
          d="M814.249 1053.25C806.974 981.152 875.999 950.751 964.249 944.451C1052.5 938.151 1126.75 958.451 1133.92 1030.55C1141.1 1102.65 1075.52 1166.18 987.249 1172.45C898.974 1178.73 821.524 1125.35 814.249 1053.25Z"
          fill="#BDE5EE"
        />
        <path
          d="M814.026 1051C806.926 980.548 876.001 950.723 964.276 944.448C1052.55 938.173 1126.63 957.873 1133.73 1028.3C1140.83 1098.72 1075 1160.95 986.751 1167.2C898.501 1173.45 821.126 1121.5 814.026 1051Z"
          fill={RoboyuColorTheme[colorTheme].face_body_outline}
        />
        <path
          d="M828.725 1047.18C822.1 981.701 886.225 953.951 968.375 948.126C1050.52 942.301 1119.3 960.626 1125.87 1026.1C1132.45 1091.58 1071.32 1149.38 989.25 1155.2C907.175 1161.03 835.325 1112.68 828.725 1047.18Z"
          fill={RoboyuColorTheme[colorTheme].face_body_2}
        />
        <path
          d="M1118.17 998.273C1096.97 955.398 1037.35 943.273 968.374 948.123C886.324 953.948 822.099 981.698 828.724 1047.17C829.545 1055.4 831.419 1063.49 834.299 1071.25C859.049 1077.61 884.451 1081.09 909.999 1081.62C1022.87 1085.65 1090.85 1044.65 1118.17 998.273Z"
          fill={RoboyuColorTheme[colorTheme].face_body_1}
        />
        <path
          d="M1062.6 1024.57L1045.95 1025.6L1044.55 1013.65L1011.63 1015.7L1013.03 1027.62L995.25 1028.72L996.425 1038.85L983.025 1039.67L984.225 1050.05L973.6 1050.7L963.8 1051.3L962.575 1040.7L948.05 1041.6L946.875 1031.52L927.425 1032.72L926.125 1021.65L893.2 1023.7L894.5 1034.75L879.525 1035.67L884.225 1076.15L902.925 1075L905.375 1096.07L938.75 1094.02L940.65 1110.52L963.75 1109.1L965.05 1120.25L997.975 1118.22L996.675 1107.07L1019.25 1105.67L1017.35 1089.2L1051.33 1087.1L1048.9 1066.17L1067.3 1065.05L1062.6 1024.57Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_2}
        />
        <path
          d="M1061.75 1024.62L1045.95 1025.6L1044.55 1013.65L1011.62 1015.7L1013.02 1027.62L995.25 1028.72L996.425 1038.85L983.025 1039.67L984.225 1050.05L973.6 1050.7L963.8 1051.3L962.575 1040.7L948.05 1041.6L946.875 1031.6L927.425 1032.8L926.125 1021.72L893.2 1023.77L894.5 1034.82L879.5 1035.75L884.2 1076.22L902.9 1075.07L903.825 1082.95C912.35 1083.8 921.525 1084.47 931.325 1084.9C1003.62 1087.95 1041.7 1057.65 1061.75 1024.62Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_1}
        />
        <path
          d="M1020 1213.2C955.65 1217.37 904.275 1200.15 863.65 1173.42C909.95 1208.82 966.7 1230.47 1025.73 1226.3C1102.98 1220.8 1167.53 1172.22 1206.7 1109.88C1171.08 1161.5 1113.35 1207.17 1020 1213.2Z"
          fill="#BDE5EE"
        />
        <path
          d="M1208.73 857.848C1174.08 839.498 1179.28 979.248 1182.85 996.773C1186.43 1014.3 1373.18 1152.32 1407.85 1136.97C1442.53 1121.62 1350 932.648 1208.73 857.848Z"
          fill="white"
        />
        <path
          d="M1191.12 865.852C1183.62 904.077 1213.77 978.502 1222.02 991.502C1231.32 1006.15 1344.95 1110.78 1411.17 1134.55C1410.25 1135.61 1409.12 1136.46 1407.85 1137.05C1373.17 1152.4 1186.45 1014.4 1182.85 996.852C1180 983.127 1176.3 895.327 1191.12 865.852Z"
          fill="#98B1DC"
        />
        <path
          d="M1182.85 996.775C1181.16 983.793 1180.33 970.716 1180.35 957.625C1182.45 975.125 1185.73 995.125 1187.85 998.125C1195.1 1008.52 1302.85 1099.5 1379.78 1130.35C1387.97 1133.75 1396.5 1136.26 1405.22 1137.85C1364.77 1146.1 1186.38 1014 1182.85 996.775Z"
          fill="#BDE5EE"
        />
        <path
          d="M892.999 181.95C892.999 181.95 1017 34.0001 1038.62 36.5001C1060.25 39.0001 1123.02 85.5501 1123.02 85.5501C1123.02 85.5501 1264.92 31.7751 1265.52 38.0501C1266.12 44.3251 1151.25 181.725 1139.12 182.5C1127 183.275 1031.1 141.175 1031.1 141.175C1031.1 141.175 877.499 198.725 892.999 181.95Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_2}
        />
        <path
          d="M1123.02 85.5751C1123.02 85.5751 1060.25 39.0001 1038.63 36.5001C1017 34.0001 893 181.95 893 181.95C895.5 183.825 1050.9 100.6 1053.42 101.775C1055.95 102.95 1131.57 137.65 1136.15 135.675C1140.72 133.7 1258.1 46.8501 1265.57 37.9751C1265 31.8001 1123.02 85.5751 1123.02 85.5751Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_1}
        />
        <path
          d="M1310.55 670.201C1310.55 928.526 1091.6 929.001 821.525 929.001C551.45 929.001 332.5 928.526 332.5 670.201C332.5 411.876 551.45 202.426 821.525 202.426C1091.6 202.426 1310.55 411.851 1310.55 670.201Z"
          fill="white"
        />
        <path
          d="M821.525 928.998C1091.52 928.998 1310.55 928.648 1310.55 670.323C1310.54 654.649 1309.7 638.986 1308.05 623.398C1215.3 728.173 990.55 879.648 597.6 834.023C478.25 820.148 397.275 792.673 343.225 758.598C390.375 928.573 586.6 928.998 821.525 928.998Z"
          fill="#98B1DC"
        />
        <path
          d="M1202.05 615.001C1202.05 836.401 1016.3 836.701 787.051 836.701C557.801 836.701 372.051 836.401 372.051 615.001C372.051 393.601 557.801 296.301 787.051 296.301C1016.3 296.301 1202.05 393.626 1202.05 615.001Z"
          fill="#BDE5EE"
        />
        <path
          d="M1199.58 611.826C1188.18 831.001 1002.4 831.301 773.275 831.301C544.15 831.301 358.4 831.001 369.775 611.826C381.15 392.651 571.925 296.301 801.05 296.301C1030.18 296.301 1210.95 392.651 1199.58 611.826Z"
          fill={RoboyuColorTheme[colorTheme].face_body_outline}
        />
        <path
          d="M1193.88 613.525C1182.95 824 1003.65 824.3 782.5 824.3C561.35 824.3 382.075 824 393.025 613.525C403.975 403.05 588.025 310.5 809.175 310.5C1030.33 310.5 1204.8 403.025 1193.88 613.525Z"
          fill={RoboyuColorTheme[colorTheme].face_body_2}
        />
        <path
          d="M1190.92 548.275C1165.92 383.8 1005.92 310.5 809.175 310.5C588.025 310.5 403.95 403 393.025 613.525C392.138 629.026 392.456 644.573 393.975 660.025C430.75 708.55 500.7 748.1 624.975 762.95C926.575 799 1108 661.5 1190.92 548.275Z"
          fill={RoboyuColorTheme[colorTheme].face_body_1}
        />
        <path
          d="M613.475 528.35C595 516.5 574.45 507.875 554.775 498.65C538.475 491 522.133 483.5 505.75 476.15C494.625 471.15 480.3 481.825 475.75 495.775C470.75 511.275 477.075 525.375 488.25 530.375C504.217 537.542 520.125 544.85 535.975 552.3H535.825C516.208 558.6 496.558 564.792 476.875 570.875C447.65 579.875 454.375 634.15 483.625 625.1C521.125 613.575 558.625 602.425 595.775 588.65C603.275 585.825 611.875 583.275 618.275 576.3C632.825 560.1 627.225 537.1 613.475 528.35ZM587.3 577.95C587.457 578.065 587.625 578.165 587.8 578.25C590.6 579.7 589.375 580.6 587.3 577.95Z"
          fill={RoboyuColorTheme[colorTheme].eyes}
        />
        <path
          d="M878.174 575.026C883.574 582.076 892.224 584.776 899.899 587.726C937.274 602.076 975.674 613.826 1013.8 625.976C1043.65 635.501 1061.55 581.501 1031.77 572.026C1011.77 565.643 991.774 559.135 971.774 552.501H971.599C990.216 545.318 1008.85 538.318 1027.5 531.501C1034.27 528.947 1039.97 524.158 1043.66 517.927C1047.35 511.696 1048.8 504.394 1047.77 497.226C1045.7 483.226 1032.35 472.351 1019.37 477.226C1000.21 484.276 981.082 491.468 961.999 498.801C938.924 507.676 915.149 515.951 892.749 527.426C876.174 535.726 865.574 558.551 878.174 575.026Z"
          fill={RoboyuColorTheme[colorTheme].eyes}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4220_34006"
          x="292.5"
          y="0.46875"
          width="1414.3"
          height="2043.46"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="20" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.3375 0 0 0 0 0.3375 0 0 0 0 0.3375 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4220_34006"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4220_34006"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
